export default {"src":"/_next/static/media/tiktok-icon.36c17f63.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};